import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { trainingOnGetDetailProyectsByEnterpiseId } from "../../api/petitionsTraining";
import { icons } from "../../assets";

export const CardUsersPerProyect = () => {
    const { enterpiseid } = useSelector((state) => state.auth);
    const [proyectInfo, setProyectInfo] = useState([]);
    useEffect(() => {
        const getDataApi = async () => {
            const result = await trainingOnGetDetailProyectsByEnterpiseId(enterpiseid);
            console.log(result)
            const infoProyects = result.payload.data.map((proyect) => {
                let usersSum = 0;
                proyect.groups.forEach((element) => {
                    usersSum += element.studentsCount;
                });
                return { proyectName: proyect.proyect.name, users: usersSum };
            });

            setProyectInfo(infoProyects);
        };
        getDataApi();
    }, [enterpiseid]);

    return (
        <div className="w-full h-full pt-6  flex flex-wrap">
            {proyectInfo.length >= 1 &&
                proyectInfo.map((proyect, i) => <ItemCard key={i} proyect={proyect.proyectName} number={proyect.users}></ItemCard>)}
        </div>
    );
};
const ItemCard = ({ proyect = "none", number = 0, percent }) => {
    return (
        <div className={` ${proyect.length !== 2 ? "w-1/2" : "w-1/3"} h-[107px] border-r my-2 border-gray-200`}>
            <p className="text-xs font-normal pl-4">{proyect}</p>
            <div className="w-full flex justify-center items-center h-16">
                <p className="text-4xl font-normal text-center ">{number}</p>
            </div>
            <div className="w-full flex justify-center items-center h-8 ">
                <img src={icons.arrowGreenUp} className="w-4 mr-1" alt="" />
                <p className="font-normal text-md text-[#9A9A9A]">Desde la última semana</p>
            </div>
        </div>
    );
};

export default CardUsersPerProyect;
